export var Locale;
(function (Locale) {
    Locale["Arabic"] = "ar";
    Locale["Basque"] = "eu";
    Locale["Bulgarian"] = "bg";
    Locale["Catalan"] = "ca";
    Locale["Chinese"] = "zh";
    Locale["ChineseTraditional"] = "zh-TW";
    Locale["Croatian"] = "hr";
    Locale["Czech"] = "cs";
    Locale["Danish"] = "da";
    Locale["Deutsch"] = "de";
    Locale["Dutch"] = "nl";
    Locale["English"] = "en";
    Locale["Estonian"] = "et";
    Locale["Finnish"] = "fi";
    Locale["French"] = "fr";
    Locale["Greek"] = "el";
    Locale["Hebrew"] = "he";
    Locale["Hungarian"] = "hu";
    Locale["Icelandic"] = "is";
    Locale["Indonesian"] = "id";
    Locale["Italian"] = "it";
    Locale["Japanese"] = "ja";
    Locale["Korean"] = "ko";
    Locale["Lithuanian"] = "lt";
    Locale["Norwegian"] = "no";
    Locale["Polish"] = "pl";
    Locale["Portuguese"] = "pt";
    Locale["Romanian"] = "ro";
    Locale["Russian"] = "ru";
    Locale["Slovenian"] = "sl";
    Locale["Spanish"] = "es";
    Locale["Swedish"] = "sv";
    Locale["Thai"] = "th";
    Locale["Turkish"] = "tr";
    Locale["Ukrainian"] = "uk";
    Locale["Vietnamese"] = "vi";
})(Locale || (Locale = {}));
//# sourceMappingURL=locale.types.js.map